import { getStatuses } from '../../lib/statuses'
import { Key } from './Key'
import { useEffect } from 'react'
import { ENTER_TEXT, DELETE_TEXT } from '../../constants/strings'
import { localeAwareUpperCase } from '../../lib/words'
import ReactNativeHapticFeedback from "react-native-haptic-feedback";
import ReactGA from 'react-ga4';

type Props = {
  onChar: (value: string) => void
  onDelete: () => void
  onEnter: (skipped: boolean) => void
  guesses: string[]
  isRevealing?: boolean
}

const options = {
  enableVibrateFallback: true,
  ignoreAndroidSystemSettings: false
};

export const Keyboard = ({
  onChar,
  onDelete,
  onEnter,
  guesses,
  isRevealing,
}: Props) => {
  const charStatuses = getStatuses(guesses)

  var countClick =0; 

  const onClick = (value: string) => {
    ReactNativeHapticFeedback.trigger("impactMedium", options);

    countClick++; 

    if (value === 'ENTER') {
      onEnter(false)
      ReactGA.event({
        category: "interaction",
        action: "click",
        label: "Enter",
        value: countClick,
        nonInteraction: false,
      })
    } 
    else if (value === 'DELETE') {
      onDelete()
      ReactGA.event({
        category: "interaction",
        action: "click",
        label: "Backspace",
        value: countClick,
        nonInteraction: false,
      })
    } 
    else if (value === "SPACE"){
      onChar(" ")
      ReactGA.event({
        category: "interaction",
        action: "click",
        label: "tap",
        value: countClick,
        nonInteraction: false,
      })
    } 
    else if (value === "SKIP"){
      onEnter(true)
      ReactGA.event({
        category: "interaction",
        action: "click",
        label: "Tab",
        value: countClick,
        nonInteraction: false,
      })
    } 
    else {
      onChar(value)
      ReactGA.event({
        category: "interaction",
        action: "click",
        label: "tap",
        value: countClick,
        nonInteraction: false,
      })
    }
  }

  useEffect(() => {
    var countKey = 0; 
    const listener = (e: KeyboardEvent) => {

      countKey++; 

      if (e.code === 'Enter') {
        onEnter(false)
        ReactGA.event({
          category: "interaction",
          action: "keyboard",
          label: e.code,
          value: countKey,
          nonInteraction: false,
        })
      } 
      else if (e.code === 'Backspace') {
        onDelete()
        ReactGA.event({
          category: "interaction",
          action: "keyboard",
          label: e.code,
          value: countKey,
          nonInteraction: false,
        })
      }
      else if (e.code === "Space"){
        onChar(" ")
        ReactGA.event({
          category: "interaction",
          action: "keyboard",
          label: "key",
          value: countKey,
          nonInteraction: false,
        })
      }
      else if (e.code === "Tab"){
        onEnter(true)
        ReactGA.event({
          category: "interaction",
          action: "keyboard",
          label: e.code,
          value: countKey,
          nonInteraction: false,
        })
      }
      else {
        const key = localeAwareUpperCase(e.key)
        // TODO: check this test if the range works with non-english letters
        if (key.length === 1 && key >= 'A' && key <= 'Z') {
          onChar(key)
        }
        else if (key.length === 1 && (key === "'" || key === "-")){
          onChar(key)
        }

        ReactGA.event({
          category: "interaction",
          action: "keyboard",
          label: "key",
          value: countKey,
          nonInteraction: false,
        })
      }
    }
    window.addEventListener('keyup', listener)
    return () => {
      window.removeEventListener('keyup', listener)
    }
  }, [onEnter, onDelete, onChar])

  return (
    <div>
      <div className="flex justify-center mb-1">
        {['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={onClick}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1">
        {['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={onClick}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1">
        <Key width={65.4} value="ENTER" onClick={onClick}>
          {ENTER_TEXT}
        </Key>
        {['Z', 'X', 'C', 'V', 'B', 'N', 'M'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={onClick}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
        <Key width={65.4} value="DELETE" onClick={onClick}>
          {DELETE_TEXT}
        </Key>
      </div>
      <div className="flex justify-center">
        <Key width={65.4} height={37} value="SKIP" onClick={onClick}>
          {"Next Hint"}
        </Key>
        <Key width={40} height={37} value="-" onClick={onClick} key="-" status={charStatuses["-"]} isRevealing={isRevealing}>
          {"-"}
        </Key>
        <Key width={130.8} height={37} value="SPACE" status={charStatuses[" "]} onClick={onClick}>
          {"Space"}
        </Key>

        <Key width={40} height={37}value="'" onClick={onClick}  key="'" status={charStatuses["'"]} isRevealing={isRevealing}>
          {"'"}
        </Key>
        <Key width={65.4} height={37}value="" onClick={onClick}>
          {""}
        </Key>
      </div>


    </div>
  )
}
